import React, { useState } from 'react';
import '../App.css';

const VideoSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleVideoSize = () => {
    setIsExpanded(!isExpanded);
  };

  const videoUrl = "https://www.youtube.com/embed/kJwZgF1-1nw";

  return (
    <section className="video-section">
      <div 
        className="video-container" 
        onClick={toggleVideoSize} 
        style={{ cursor: 'pointer' }}
      >
        <iframe
          width={isExpanded ? '1100' : '900'}
          height={isExpanded ? '619' : '506'}
          src={videoUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          style={{ borderRadius: '20px', background: '#000' }}
        ></iframe>
      </div>
    </section>
  );
};

export default VideoSection;
